const normalizeAccessContext = source => {
  if (!source) {
    return {
      isAdmin: false,
      isOwner: false,
      isLoggedInViaSSO: false,
      permissions: {},
    };
  }

  return {
    isAdmin: source.isAdmin === true,
    isOwner: source.isOwner === true,
    isLoggedInViaSSO: source.isLoggedInViaSSO === true,
    permissions: source.getPermissions ?? source.permissions ?? {},
  };
};

const getPermissionValue = (permissions, permissionKey) => {
  if (!permissionKey) return undefined;

  return permissionKey.split('.').reduce((value, key) => value?.[key], permissions ?? {});
};

export const hasPermission = (permissions, permissionKey) => {
  if (!permissionKey) return true;

  if (permissionKey.includes('||')) {
    const keys = permissionKey.split('||').map(key => key.trim()).filter(Boolean);
    return keys.length > 0 && keys.some(key => hasPermission(permissions, key));
  }

  return getPermissionValue(permissions, permissionKey) === true;
};

export const canAccessRoute = (route, source) => {
  if (!route) return false;

  if (Array.isArray(route.matched) && route.matched.length === 0) {
    return false;
  }

  const { isAdmin, isOwner, isLoggedInViaSSO, permissions } = normalizeAccessContext(source);
  const meta = route.meta ?? {};

  if (meta.ssoRestricted && isLoggedInViaSSO) return false;
  if (meta.ownerOnly && !isOwner) return false;
  if (meta.adminOnly && !isAdmin) return false;

  if (!meta.permissionKey) return true;
  if (meta.permissionKey === 'admin') return isAdmin;

  return hasPermission(permissions, meta.permissionKey);
};

export const canAccessRoutePath = (router, path, source) => {
  if (!router || !path) return false;
  return canAccessRoute(router.resolve(path), source);
};